import { render } from "./AccordionView.vue?vue&type=template&id=ee6d57f4&scoped=true"
import script from "./AccordionView.vue?vue&type=script&lang=js"
export * from "./AccordionView.vue?vue&type=script&lang=js"

import "./AccordionView.vue?vue&type=style&index=0&id=ee6d57f4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee6d57f4"]])

export default __exports__